import { useMemo } from 'react';
import { useQuery } from '@tanstack/react-query';
import { tenantApi } from '../../api/endpoints/tenant';
import { catalogApi } from '../../api/endpoints/catalog';
import { useAuth } from '../../hooks/useAuth';
import { useLabelResolver } from '../../hooks/useLabelResolver';
import { PermissionMatrixView } from './PermissionMatrixView';

/** Matriz del propio tenant del actor: sus roles, su catálogo y su resolvedor de etiquetas. */
export function TenantPermissionMatrix() {
    const { user } = useAuth();
    const tid = user?.tenantId ?? '';
    const labels = useLabelResolver();

    const rolesQ = useQuery({
        queryKey: ['tenant', tid, 'roles'],
        queryFn: () => tenantApi.listRoles(tid),
        enabled: !!tid,
    });
    const catalogQ = useQuery({
        queryKey: ['catalog', 'permissions', 'self'],
        queryFn: () => catalogApi.listPermissions(),
        staleTime: 5 * 60_000,
    });

    const roles = useMemo(() => rolesQ.data?.items ?? [], [rolesQ.data]);
    const catalog = useMemo(() => catalogQ.data?.items ?? [], [catalogQ.data]);

    return (
        <PermissionMatrixView
            roles={roles}
            catalog={catalog}
            labels={labels}
            isPending={rolesQ.isPending || catalogQ.isPending}
            isError={rolesQ.isError || catalogQ.isError}
            onRetry={() => {
                if (rolesQ.isError) void rolesQ.refetch();
                if (catalogQ.isError) void catalogQ.refetch();
            }}
        />
    );
}
